<template>
  <div :class="[`group-460-1`, className || ``]">
    <div class="rectangle-41"></div>
    <div class="text-15 poppins-bold-white-20px">Новости</div>
  </div>
</template>

<script>
export default {
  name: "Group460",
  props: ["className"],
};
</script>

<style>
.group-460-1 {
  height: 38px;
  left: 220px;
  position: absolute;
  top: 168px;
  width: 132px;
  cursor: pointer;
}

.rectangle-41 {
  background-color: var(--azure-radiance);
  border-radius: 80px;
  height: 38px;
  left: 0;
  position: absolute;
  top: 0;
  width: 130px;
}

.text-15 {
  left: 19px;
  letter-spacing: 0.4px;
  line-height: 36px;
  position: absolute;
  top: 2px;
  white-space: nowrap;
  width: 91px;
}

.group-460-1.group-39 {
  height: 41px;
  left: 0;
  position: absolute;
  top: 333px;
  width: 132px;
}

.group-460-1.group-39 .rectangle-41 {
  height: 41px;
}

.group-460-1:hover .rectangle-41 {
  opacity: 0.8;
}
</style>
